import '.a{display:flex;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.d7{background:var(--palette-white);}.ssr-plugin'
import '.b3{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.aw{max-width:77.5rem;}.ssr-plugin'
import '.fj{justify-content:stretch;}.ssr-plugin'
import '.bd{position:sticky;}.ssr-plugin'
import '.be{top:0px;}.ssr-plugin'
import '.bf{z-index:10;}.ssr-plugin'
import '.fy{padding-block:1rem;}.ssr-plugin'
import '.fz{height:3rem;}.ssr-plugin'
import '.bs{justify-content:space-between;}.ssr-plugin'
import '.c2{flex-wrap:wrap;}.ssr-plugin'
import '.g0{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ei{margin-top:2rem;}.ssr-plugin'
import '.g1{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a af ab b d7"
      >
        <div className="b3 a r ab b"
        >
          <div className="aw a b fj bd be bf d7"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fy fz a bs r c2"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="g0 a b af ei g1 aw"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
